class ToastShiftsService {
  // Global state / source of truth for disabling all toast shift import activities
  _importsDisabled = false;
  constructor(
    $location,
    EventCollection,
    ShiftsEducation,
    AlertService,
    Authentication,
    $rootScope,
    cfpLoadingBar
  ) {
    'ngInject';

    Object.assign(this, {
      $location,
      EventCollection,
      ShiftsEducation,
      Authentication,
      AlertService,
      $rootScope,
      cfpLoadingBar,
    });

    this.$rootScope.$on('socket:shifts:import:complete', this.shiftsComplete);
    this.$rootScope.$on('socket:shifts:import:inprogress', this.shiftsInProgress);
  }

  shiftsComplete = (event, data) => {
    this.cfpLoadingBar.complete();
    this.$rootScope.$broadcast('ToastShiftsService:shiftsComplete');
    this.alertImportResult(data.shifts_added);
    this.ShiftsEducation.showToastImportShiftEducation();
    this._importsDisabled = false;
  };

  shiftsInProgress = (event, data) => {
    this._importsDisabled = true;
    this.$rootScope.$broadcast('ToastShiftsService:shiftsInProgress');
    this.cfpLoadingBar.start();
    this.cfpLoadingBar.set(data.percent / 100);
  };

  importToastShiftsSideEffect() {
    this.$rootScope.$broadcast('socket:shifts:import:inprogress', { percent: 0 });
    this._importsDisabled = true;
  }

  importToastShifts(date, calendarSpan) {
    this.Authentication.sendRequest({
      method: 'post',
      path: `integrations/toast/shifts`,
      payload: { date, calendarSpan },
    });
    this.importToastShiftsSideEffect();
  }

  get importsDisabled() {
    return this._importsDisabled;
  }

  get displayMode() {
    return this.$location.search().mode;
  }

  get displayTab() {
    return this.$location.search().tab;
  }

  alertImportResult(shifts_added) {
    if (shifts_added) {
      this.AlertService.success(`${shifts_added} shifts imported from Toast!`);
      return;
    }
    this.AlertService.warning(`0 shifts imported from Toast!`);
  }
}

export default ToastShiftsService;
